import { useState, useCallback } from 'react';
import { FilterState } from '../types';

export const useHospitalUI = (
  setFilters: (fn: (prev: FilterState) => FilterState) => void,
  setCurrentPage: (page: number) => void,
  currentPage: number,
  totalPages: number
) => {
  const [expandedCards, setExpandedCards] = useState<Set<string>>(new Set());
  const [selectedMatches, setSelectedMatches] = useState<Record<string, string>>({});

  const toggleCardExpansion = useCallback((id: string) => {
    setExpandedCards(prev => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  }, []);

  const updateFilters = useCallback((newFilters: Partial<FilterState>) => {
    setFilters(prev => ({ ...prev, ...newFilters }));
    setCurrentPage(1);
  }, [setFilters, setCurrentPage]);

  const changePage = useCallback((direction: number) => {
    const newPage = currentPage + direction;
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  }, [currentPage, totalPages, setCurrentPage]);

  const setSelectedMatch = useCallback((hospitalId: string, matchId: string) => {
    setSelectedMatches(prev => ({ ...prev, [hospitalId]: matchId }));
  }, []);

  return {
    expandedCards,
    selectedMatches,
    toggleCardExpansion,
    updateFilters,
    changePage,
    setSelectedMatch,
    setSelectedMatches
  };
};